// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__8u6Oo","main":"index_main__NvCNi"};